import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  PayrollCreateContractorInput,
  PayrollCreateContractorGraphQLRequest,
  PayrollCreateEmployeeResponse,
} from '../types';

const payrollCreateContractorMutation = gql`
  mutation PayrollCreateContractor($input: PayrollCreateContractorInput!) {
    payrollCreateContractor(input: $input) {
      code
      success
      message
      data {
        peopleId
        inviteSent
      }
    }
  }
`;

export const createContractor = (input: PayrollCreateContractorInput) => {
  return graphQLApi<PayrollCreateEmployeeResponse, PayrollCreateContractorGraphQLRequest>({
    query: payrollCreateContractorMutation,
    queryVariables: { input },
  });
};
